/* unplugin-vue-components disabled */import script from "./NoteSend.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteSend.vue?vue&type=script&setup=true&lang=js"

import "./NoteSend.vue?vue&type=style&index=0&id=fa49ccf0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa49ccf0"]])

export default __exports__